import { useContextSelector } from "use-context-selector";
import BetSlipContext from "../../context/BetSlipContext";
import MatchOddsFav from "../Favourite/MatchOddsFav";
import { isEmpty } from "lodash";
import AuthContext from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import SportBookFav from "../Favourite/SportBookFav";
import { useFavoritesLogic } from "../useLogic/useFavoritesLogic";
const MyFav = () => {
  const setLimit = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setLimit;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const defaultStakeLimit = useContextSelector(AuthContext, (ctx) => {
    return ctx.defaultStakeLimit;
  });
  const setBetSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setBetSlipObject;
  });
  const setShowBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setShowBetDialog;
  });
  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });
  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });
  const {
    list,
    position,
    loader,
    odds,
    oddsHistory,
    active,
    handleActive,
    addToFavourite,
  } = useFavoritesLogic();
  const navigate = useNavigate();
  return list?.length > 0 ? (
    <div className="s-px-2 s-pb-2 s-pt-10px s-min-h-full-with-header s-pb-20px">
      {list?.map((res) => {
        let matchOdds =
          odds[res?.eventId]?.find((item) => {
            return item?.type == "odds";
          })?.data || {};
        let matchOddsOld =
          odds[res?.eventId]?.find((item) => {
            return item?.type == "odds";
          })?.data || {};
        // let matchBookmaker =
        //   odds[res?.eventId]?.find((item) => {
        //     return item?.type == "bookmaker";
        //   })?.data || {};

        // let matchFancy =
        //   odds[res?.eventId]
        //     ?.find((item) => {
        //       return item?.type == "fancy";
        //     })
        //     ?.data?.filter((item) => {
        //       return item?.eventId == res?.eventId;
        //     }) || {};

        let matchSportBook =
          odds[res?.eventId]
            ?.find((item) => {
              return item?.type == "sportbook";
            })
            ?.data?.filter((item) => {
              return item?.betfairEventId == res?.eventId;
            }) || {};

        let getActive = active?.find((obj) => {
          return obj?.eventId == res?.eventId;
        });
        let updatedPosition =
          position?.length > 0
            ? position?.find((obj) => {
                return obj?.eventId == res?.eventId;
              }) || {}
            : {};
        return (
          <div
            data-v-b7a97d9f
            className="s-px-3px s-mb-2 s-rounded-5px s-bg-white dark:s-bg-[rgba(255,255,255,0.05)] s-text-global-font-default-light dark:s-text-global-font-default-dark s-shadow-2sm"
          >
            <div
              onClick={() =>
                navigate(`/match-detail/${res?.eventId}/${res?.marketId}`)
              }
              data-v-b7a97d9f
              className="s-py-10px s-px-2 s-relative"
            >
              <div
                data-v-b7a97d9f
                className="s-sub-row s-grid s-justify-between s-items-center"
              >
                <div
                  data-v-b7a97d9f
                  className="s-flex s-justify-start s-items-center s-space-x-1"
                >
                  <p
                    data-v-b7a97d9f
                    className="s-text-17px s-font-bold s-leading-140 s-text-right s-truncate"
                  >
                    {res?.eventName}
                  </p>
                </div>
                <div
                  data-v-b7a97d9f
                  className="s-flex s-items-center s-ml-auto"
                ></div>
              </div>
            </div>
            {res?.Odds?.length > 0 &&
              res?.Odds?.map((item) => {
                let oddsInner =
                  matchOdds?.length > 0
                    ? matchOdds?.find((obj) => {
                        return obj?.mi == item?.marketId;
                      })
                    : {};
                let OldoddsInner =
                  matchOddsOld?.length > 0
                    ? matchOddsOld?.find((obj) => {
                        return obj?.mi == item?.marketId;
                      })
                    : {};
                let backOdds =
                  !isEmpty(oddsInner) && oddsInner?.rt?.length > 0
                    ? oddsInner?.rt?.filter((rt) => rt.ib)
                    : [];

                let layOdds =
                  !isEmpty(oddsInner) && oddsInner?.rt?.length > 0
                    ? oddsInner?.rt?.filter((rt) => !rt.ib)
                    : [];
                let OldbackOdds =
                  !isEmpty(OldoddsInner) && OldoddsInner?.rt?.length > 0
                    ? OldoddsInner?.rt?.filter((rt) => rt.ib)
                    : [];

                let OldlayOdds =
                  !isEmpty(OldoddsInner) && OldoddsInner?.rt?.length > 0
                    ? OldoddsInner?.rt?.filter((rt) => !rt.ib)
                    : [];
                let ms = !isEmpty(oddsInner)
                  ? oddsInner?.ms
                  : item?.totalMatched;
                let totalMatched = !isEmpty(oddsInner)
                  ? oddsInner?.totalMatched
                  : 0;

                return (
                  <MatchOddsFav
                    active={getActive?.Odds}
                    addToFavioute={addToFavourite}
                    handleActive={handleActive}
                    totalMatched={totalMatched}
                    ms={ms}
                    layOdds={layOdds}
                    backOdds={backOdds}
                    oldBack={OldbackOdds}
                    oldLay={OldlayOdds}
                    OuterObject={res}
                    object={item}
                    betSlipObject={betSlipObject}
                    showBetDialog={showBetDialog}
                    user={user}
                    setShowBetDialog={setShowBetDialog}
                    setBetSlipObject={setBetSlipObject}
                    setToastObject={setToastObject}
                    defaultStakeLimit={defaultStakeLimit}
                    setLimit={setLimit}
                    position={updatedPosition?.betFair || []}
                    profileData={
                      item?.matchSetting?.length > 0
                        ? {
                            ...item,
                            arrayCheck: "details",
                            profile: profileData,
                          }
                        : {
                            ...profileData,
                            arrayCheck: "profile",
                            profile: profileData,
                          }
                    }
                  />
                );
              })}
            {/* <div data-v-b7a97d9f>
              <section>
                <div className="s-pb-1">
                  <div className="s-relative s-h-34px s-py-1.5 s-pr-9 s-pl-2 s-text-sm s-text-primary s-bg-primary s-rounded-3px s-cursor-pointer s-transition-all s-duration-300 s-rounded-t-3px s-rounded-b-none">
                    <div className="s-flex s-justify-start s-items-center s-text-market-name">
                      <i className="s-text-15px s-icon-star-solid s-h-25px s-flex s-items-center s-mr-5px s-pb-2px" />
                      <p className="sm:-s-ml-1 s-pr-2 s-h-14px s-text-16px s-font-bold">
                        Bookmaker
                      </p>
                    </div>
                    <span className="s-icon-arrow-down-sencodary s-absolute s-right-4 s-top-3 s-text-12px s-text-market-name s-transition-transform s-origin-center s-duration-300 s-transform s-rotate-180" />
                  </div>
                  <div className="s-px-1 s-bg-white dark:s-bg-black-800 s-rounded-bl-lg s-rounded-br-lg">
                    <div className="s-py-1px s-flex s-justify-between s-items-center">
                      <div className="s-flex-1" />
                      <div className="s-w-129px s-flex s-gap-1px s-text-14px s-font-bold s-leading-140">
                        <div className="s-w-64px s-text-center s-text-global-font-default-light dark:s-text-global-font-default-dark">
                          Back
                        </div>
                        <div className="s-w-64px s-text-center s-text-global-font-default-light dark:s-text-global-font-default-dark">
                          Lay
                        </div>
                      </div>
                    </div>
                    <div data-v-635307b5>
                      <div
                        data-v-635307b5
                        className="s-relative s-flex s-items-center s-justify-center s-flex-col s-gap-1px"
                      >
                        <div data-v-635307b5 className="s-w-full">
                          <div
                            data-v-635307b5
                            className="s-w-full s-relative s-flex s-justify-start s-items-center s-bg-black-100 dark:s-bg-black-700"
                          >
                            <div
                              data-v-635307b5
                              className="s-px-2 s-h-full s-flex s-flex-1 s-flex-col s-justify-center"
                            >
                              <p
                                data-v-635307b5
                                className="s-text-17px s-font-bold s-leading-120 s-break-all s-text-global-font-default-light dark:s-text-global-font-default-dark"
                              >
                                South Africa A
                              </p>
                              <div
                                data-v-635307b5
                                className="s-text-12px s-leading-150 s-flex"
                                data-testid="forecast"
                              ></div>
                            </div>
                            <div
                              data-v-635307b5
                              className="s-bg-bookmaker-market s-w-129px s-relative s-grid s-grid-cols-2 s-gap-x-2 s-p-1 s-rounded-3px s-self-start s-h-48px"
                            >
                              <div
                                data-v-21a9d2fa
                                data-v-635307b5
                                className="s-h-42px s-text-center s-rounded-3px s-border s-border-white s-flex s-items-center s-justify-center s-relative s-overflow-hidden s-bg-back-300 dark:s-bg-back-400-dark"
                                title="BACK"
                              >
                                <div
                                  data-v-2f9c23fd
                                  data-v-21a9d2fa
                                  className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                                  style={{ "--0b879273": "0" }}
                                >
                                  <span
                                    data-v-2f9c23fd
                                    className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                                    style={{ display: "none" }}
                                  />
                                  <span
                                    data-v-2f9c23fd
                                    className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                                    style={{ display: "none" }}
                                  />
                                </div>
                                <h3
                                  data-v-21a9d2fa
                                  className="s-text-17px s-font-bold s-text-global-font-default-light"
                                >
                                  24.00
                                </h3>
                              </div>
                              <div
                                data-v-21a9d2fa
                                data-v-635307b5
                                className="s-h-42px s-text-center s-rounded-3px s-border s-border-white s-flex s-items-center s-justify-center s-relative s-overflow-hidden s-bg-lay-300 dark:s-bg-lay-400-dark"
                                title="LAY"
                              >
                                <div
                                  data-v-2f9c23fd
                                  data-v-21a9d2fa
                                  className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                                  style={{ "--0b879273": "0" }}
                                >
                                  <span
                                    data-v-2f9c23fd
                                    className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                                    style={{ display: "none" }}
                                  />
                                  <span
                                    data-v-2f9c23fd
                                    className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                                    style={{ display: "none" }}
                                  />
                                </div>
                                <h3
                                  data-v-21a9d2fa
                                  className="s-text-17px s-font-bold s-text-global-font-default-light"
                                >
                                  27.00
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div data-v-635307b5 className="s-w-full">
                          <div
                            data-v-635307b5
                            className="s-w-full s-relative s-flex s-justify-start s-items-center s-bg-black-100 dark:s-bg-black-700"
                          >
                            <div
                              data-v-635307b5
                              className="s-px-2 s-h-full s-flex s-flex-1 s-flex-col s-justify-center"
                            >
                              <p
                                data-v-635307b5
                                className="s-text-17px s-font-bold s-leading-120 s-break-all s-text-global-font-default-light dark:s-text-global-font-default-dark"
                              >
                                New Zealand A
                              </p>
                              <div
                                data-v-635307b5
                                className="s-text-12px s-leading-150 s-flex"
                                data-testid="forecast"
                              ></div>
                            </div>
                            <div
                              data-v-635307b5
                              className="s-bg-bookmaker-market s-w-129px s-relative s-grid s-grid-cols-2 s-gap-x-2 s-p-1 s-rounded-3px s-self-start s-h-48px"
                            >
                              <div
                                data-v-21a9d2fa
                                data-v-635307b5
                                className="s-h-42px s-text-center s-rounded-3px s-border s-border-white s-flex s-items-center s-justify-center s-relative s-overflow-hidden s-bg-back-300 dark:s-bg-back-400-dark"
                                title="BACK"
                              >
                                <div
                                  data-v-2f9c23fd
                                  data-v-21a9d2fa
                                  className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                                  style={{ "--0b879273": "0" }}
                                >
                                  <span
                                    data-v-2f9c23fd
                                    className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                                    style={{ display: "none" }}
                                  />
                                  <span
                                    data-v-2f9c23fd
                                    className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                                    style={{ display: "none" }}
                                  />
                                </div>
                                <h3
                                  data-v-21a9d2fa
                                  className="s-text-17px s-font-bold s-text-global-font-default-light"
                                />
                              </div>
                              <div
                                data-v-21a9d2fa
                                data-v-635307b5
                                className="s-h-42px s-text-center s-rounded-3px s-border s-border-white s-flex s-items-center s-justify-center s-relative s-overflow-hidden s-bg-lay-300 dark:s-bg-lay-400-dark"
                                title="LAY"
                              >
                                <div
                                  data-v-2f9c23fd
                                  data-v-21a9d2fa
                                  className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                                  style={{ "--0b879273": "0" }}
                                >
                                  <span
                                    data-v-2f9c23fd
                                    className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                                    style={{ display: "none" }}
                                  />
                                  <span
                                    data-v-2f9c23fd
                                    className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                                    style={{ display: "none" }}
                                  />
                                </div>
                                <h3
                                  data-v-21a9d2fa
                                  className="s-text-17px s-font-bold s-text-global-font-default-light"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          data-v-635307b5
                          className="s-mt-0 s-absolute s-right-0 s-top-0 s-flex s-justify-center s-items-center s-w-129px s-h-full s-bg-black-700 dark:s-bg-black-900 s-opacity-80 s-text-15px s-text-white s-rounded-3px s-z-20"
                        >
                          Suspended
                        </div>
                      </div>
                      <div
                        data-v-635307b5
                        className="s-py-8px s-flex s-justify-end s-items-center"
                      >
                        <div
                          data-v-635307b5
                          className="s-flex s-gap-3px s-items-center s-text-black-600 dark:s-text-black-400"
                          data-testid="betLimit"
                        >
                          <span className="s-icon-min-max s-text-14px" />
                          <span className="s-text-12px">Min/Max</span>
                          <span className="s-text-12px s-font-bold">
                            79/423,333
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div data-v-b7a97d9f className="s-pb-1">
              <div className="s-relative s-h-34px s-py-2 s-pr-9 s-pl-2 s-text-sm s-text-primary s-bg-primary s-rounded-3px s-cursor-pointer s-transition-all s-duration-300 s-rounded-t-3px s-rounded-b-none">
                <div className="s-flex s-justify-start s-items-center s-h-20px">
                  <p className="sm:s-ml-1px s-ml-3px s-pr-2 s-h-14px s-text-16px s-font-bold s-text-market-name">
                    Fancybet
                  </p>
                  <span className="s-icon-info-circle s-block s-w-16px s-h-16px s-text-16px s-text-market-sub-icon" />
                </div>
                <span className="s-icon-arrow-down-sencodary s-absolute s-right-4 s-top-3.5 s-text-12px s-text-market-name s-transition-transform s-origin-center s-duration-300 s-transform s-rotate-180" />
              </div>
              <div className="s-px-3px s-bg-white dark:s-bg-black-800 s-rounded-b-5px">
                <div className="s-py-1px s-flex s-justify-between s-items-center">
                  <div className="s-flex-1" />
                  <div className="s-w-129px s-flex s-gap-1px s-text-14px s-font-bold s-leading-140">
                    <div className="s-w-64px s-text-center s-text-global-font-default-light dark:s-text-global-font-default-dark">
                      No
                    </div>
                    <div className="s-w-64px s-text-center s-text-global-font-default-light dark:s-text-global-font-default-dark">
                      Yes
                    </div>
                  </div>
                </div>
                <div
                  className="s-relative"
                  selections="[object Map]"
                  dmfancybetgameproductstatus="true"
                >
                  <div className="s-flex s-justify-start s-items-center s-bg-black-100 dark:s-bg-black-700">
                    <div
                      data-v-5460a16b
                      className="s-fav s-text-global-font-default-light dark:s-text-global-font-default-dark s-text-15px s-ml-7px"
                    >
                      <div
                        data-v-5460a16b
                        className="s-relative s-icon-star-solid s-animate-star-line-box"
                      >
                        <span
                          data-v-5460a16b
                          className="s-rating-star-line s-bg-global-font-default-light dark:s-bg-global-font-default-dark"
                        />
                        <span
                          data-v-5460a16b
                          className="s-rating-star-line s-bg-global-font-default-light dark:s-bg-global-font-default-dark"
                        />
                        <span
                          data-v-5460a16b
                          className="s-rating-star-line s-bg-global-font-default-light dark:s-bg-global-font-default-dark"
                        />
                      </div>
                    </div>
                    <div className="s-flex s-flex-col s-justify-center s-h-full s-text-14px s-px-2 s-flex-1 s-my-7px s-text-global-font-default-light dark:s-text-global-font-default-dark">
                      <div className="s-flex s-flex-row">
                        <p className="s-flex-1 s-m-auto s-text-17px s-font-bold s-leading-120 s-break-words">
                          25 Over Run SA-A
                        </p>
                        <div
                          className="s-text-global-font-on-dark s-rounded-3px s-p-5px s-text-12px s-h-min s-font-normal s-ml-7px"
                          data-testid="books-btn"
                        >
                          <div className="s-invisible">Book</div>
                        </div>
                      </div>
                      <div
                        className="s-text-12px s-leading-150 s-flex"
                        data-testid="forecast"
                      ></div>
                    </div>
                    <div
                      className="s-w-129px s-relative s-grid s-gap-1px s-grid-cols-2 s-self-start dark:s-text-black-900"
                      selections="[object Map]"
                    >
                      <div
                        data-v-ebc3700d
                        className="s-pt-2 s-pb-5px s-text-center s-rounded-3px s-min-h-48px s-flex s-flex-col s-justify-center s-relative s-overflow-hidden s-bg-lay-300 dark:s-bg-lay-400-dark"
                        title="NO"
                      >
                        <div
                          data-v-2f9c23fd
                          data-v-ebc3700d
                          className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                          style={{ "--0b879273": "0" }}
                        >
                          <span
                            data-v-2f9c23fd
                            className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                            style={{ display: "none" }}
                          />
                          <span
                            data-v-2f9c23fd
                            className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                            style={{ display: "none" }}
                          />
                        </div>
                        <h3
                          data-v-ebc3700d
                          className="s-text-17px s-font-bold s-mb-2px s-leading-12px"
                        >
                          147
                        </h3>
                        <p
                          data-v-ebc3700d
                          className="s-text-11px s-h-10px s-leading-10px"
                        >
                          100
                        </p>
                      </div>
                      <div
                        data-v-ebc3700d
                        className="s-pt-2 s-pb-5px s-text-center s-rounded-3px s-min-h-48px s-flex s-flex-col s-justify-center s-relative s-overflow-hidden s-bg-back-300 dark:s-bg-back-400-dark"
                        title="YES"
                      >
                        <div
                          data-v-2f9c23fd
                          data-v-ebc3700d
                          className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                          style={{ "--0b879273": "0" }}
                        >
                          <span
                            data-v-2f9c23fd
                            className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                            style={{ display: "none" }}
                          />
                          <span
                            data-v-2f9c23fd
                            className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                            style={{ display: "none" }}
                          />
                        </div>
                        <h3
                          data-v-ebc3700d
                          className="s-text-17px s-font-bold s-mb-2px s-leading-12px"
                        >
                          148
                        </h3>
                        <p
                          data-v-ebc3700d
                          className="s-text-11px s-h-10px s-leading-10px"
                        >
                          100
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <SportBookFav
              activeOuter={getActive?.SportBook}
              handleActive={handleActive}
              addToFavioute={addToFavourite}
              betSlipObject={betSlipObject}
              showBetDialog={showBetDialog}
              matchSportBook={matchSportBook}
              object={res}
              data={res?.SportBook}
              user={user}
              position={updatedPosition?.fancyAndPremium}
              setShowBetDialog={setShowBetDialog}
              setBetSlipObject={setBetSlipObject}
              setLimit={setLimit}
              setToastObject={setToastObject}
            />
          </div>
        );
      })}
    </div>
  ) : (
    <div className="s-px-2 s-pb-2 s-pt-10px s-min-h-full-with-header s-pb-20px">
      <div className="s-flex s-justify-center s-items-center s-py-36">
        <div className="s-py-6 s-px-7 s-bg-white dark:s-bg-black-800 s-text-center s-text-global-font-default-light dark:s-text-global-font-default-dark s-text-base s-rounded-5px s-leading-tight s-shadow-2sm">
          <div
            alt
            className="s-icon-empty s-text-40px s-text-black-300 dark:s-opacity-30 s-m-auto s-mb-2.5"
          />
          <div>No Favourites Added</div>
        </div>
      </div>
    </div>
  );
};

export default MyFav;
